import React from 'react';
import './cattitle.scss';
import Carousel from  're-carousel'; // react-responsive-carousel';
import IndicatorDots from './re-carosel/src/indicator-dots';
import Buttons from './re-carosel/src/buttons';
import { umoksType } from '../../types/types.js';
// import 'react-responsive-carousel/lib/styles/main.css';

// carousel styles
// import 'react-responsive-carousel/lib/styles/carousel.css';

class CatTitle extends React.Component {
  constructor(props) {
    super(props);
  };

  getCarosel = () => {
    return (
      <Carousel loop auto widgets={[ IndicatorDots ]}>
        <div className='cat-title-content-wrap'>
          <h2 className='title-h2'>ми працюємо чесно - ми можемо собі це дозволити</h2>
        </div>
        <div className='title-content-wrap'>
          <h2 className='title-h2'>репутація і партнери - важливіше швидких грошей</h2>
        </div>
        <div className='title-content-wrap'>
          <h2 className='title-h2'>ми не віримо в чудо - ми віримо в себе</h2>
        </div>

      </Carousel>
    );
  };

  render() {
    return (
      <section className='cat-title-wrap f-center'>
        <div className='title-fone' />
        <div className='f-container title-carosel'>
          <h3 className='cat-title-h2'>"Газ АП" - надійний постачальник газу в вашому регіоні!</h3>
          <p className='cat-title-h2' ><i>ціна у червні 2021 року становить 7,99 грн. за 1 м<sup>3</sup></i></p>
          <hr />
        </div>
      </section>
    );
  };
};

CatTitle.propTypes = {
  menuList:  umoksType.isRequired
};

export default CatTitle;



// WEBPACK FOOTER //
// ./src/client/components/cattitle/cattitle.jsx